// Section 16 and 18 festivals: once a year in the policy's season (Summer or Autumn), with a
// common hall standing; costs 1 food per person and 2 wood; happiness +10 for 2 seasons (the
// festival policy's happinessTarget modifier while `festival.activeUntilTurn` holds) and trust +4
// for everyone. Held even in a hungry year if the stock covers it (the Ledger judges; Section 21).
// Constants: config.festival.
import { effectiveCount, peopleSorted } from '../../core/queries';
import type { PhaseContext } from '../../core/types';
import { remember } from '../shared/memory';
import { addStock } from '../shared/stocks';
import { applyTrust, type TrustTally } from './trust';

export function holdFestival(ctx: PhaseContext, tally: TrustTally): void {
  const policy = ctx.state.policies.festival;
  if (policy === 'off' || policy !== ctx.season.season) return;
  const f = ctx.cfg.festival;
  if (effectiveCount(ctx.cfg, ctx.state, 'common-hall') <= 0) {
    ctx.report.add({ kind: 'festival-skipped', reason: 'no-hall' });
    return;
  }
  const people = peopleSorted(ctx.state);
  const foodCost = f.foodPerPerson * people.length;
  const woodCost = f.wood;
  if (ctx.draft.stocks.food.amount < foodCost) {
    ctx.report.add({ kind: 'festival-skipped', reason: 'short-food' });
    return;
  }
  if (ctx.draft.stocks.wood.amount < woodCost) {
    ctx.report.add({ kind: 'festival-skipped', reason: 'short-wood' });
    return;
  }
  addStock(ctx, 'food', -foodCost, 'consumption');
  addStock(ctx, 'wood', -woodCost, 'consumption');
  ctx.draft.festival.lastHeldTurn = ctx.season.turn;
  ctx.draft.festival.activeUntilTurn = ctx.season.turn + f.seasons;
  for (const snap of people) {
    const p = ctx.draft.people[snap.id];
    if (p === undefined) continue;
    applyTrust(ctx, p, 'festival', tally);
    remember(ctx, p, { turn: ctx.season.turn, kind: 'festival' });
  }
  ctx.report.add({ kind: 'festival', foodCost, woodCost });
}
